import React from "react";
import {
  Table,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableBody,
  Icon,
} from "semantic-ui-react";

const COLUMNS = [
  "Type",
  "Question",
  "Answer Type",
  "Required Field?",
  "Hide",
  "Ordinal",
  "Parent ID",
  "Condition"
];

const mapTypeToAnswerType = (type) => {
  if (!type) return "-";
  if (type === "bool" || type === "bool:barCustomer" ) return "Y / N";
  if (type === "text") return "Text (2000 characters)";
  if (type === "lookup:customerState" || type === "lookup:actionOrMeasure" || type  ===  "lookup:venueEnterTime" || type === "lookup:venueEnterCount")
    return "Dropdown";
  if (type === "date:nextReview" || type === "date") return "Date";
  if (type === "number" || /^number$/i.test(type)) return "Number";
  return type;
};

const EscalatedReviewTable = ({ data = [], selectedRowId, onSelectRow }) => {
  const sortedData = data
    .slice()
    .sort((a, b) => (a.ordinal ?? a.id) - (b.ordinal ?? b.id));

  const parentIds = new Set(
    data.map((row) => row.parentId).filter((id) => id != null),
  );
  const hasChild = (row) => parentIds.has(row.id);

  return (
    <Table class="ui celled striped compact table">
      <TableHeader>
        <TableRow>
          {COLUMNS.map((col, index) => (
            <TableHeaderCell
              textAlign={index === 1 ? "left" : "center"}
              key={col}
            >
              {col}
            </TableHeaderCell>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {sortedData.map((row) => (
          <TableRow
            key={row.id}
            className="clickable"
            onClick={() => onSelectRow && onSelectRow(row)}
            active={selectedRowId === row.id}
          >
            <TableCell textAlign="center">
              {hasChild(row) ? "Custom" : "Default"}
            </TableCell>
            <TableCell textAlign="left">{row.question ?? "-"}</TableCell>
            <TableCell textAlign="center">
              {mapTypeToAnswerType(row.type)}
            </TableCell>
            <TableCell textAlign="center">{row.required ? "Yes" : "No"}</TableCell>
            <TableCell textAlign="center">
              <Icon
                name={row.isDisabled ? "check" : "close"}
                color={row.isDisabled ? "green" : "red"}
              />
            </TableCell>
            <TableCell textAlign="center">{row.ordinal ?? "-"}</TableCell>
            <TableCell textAlign="center">
              {row.parentId != null ? row.parentId : "-"}
            </TableCell>
            <TableCell textAlign="center">
              { 
                row.condition === true ? "True" : row.condition === false ? "False" : "-"
              }
            </TableCell>
          </TableRow>
        ))}
      </TableBody>  
    </Table>
  );
};

export default EscalatedReviewTable;
